import { Card, Row, Col, Tag, List, Table } from "antd";
import classes from "./operational.module.scss";
import { Typography } from "antd";
import Dashboard from "../Dashboard";
const { Title, Text } = Typography;

const RadarOverview = () => {
  // Dummy business trend data for the table
  const businessTrendData = [
    {
      key: "1",
      trend: "Automation Spike in Ops",
      category: "Operations",
      detectedOn: "2025-04-25",
      impact: "High",
    },
    {
      key: "2",
      trend: "Vendor SLA Compliance Improvement",
      category: "Vendor",
      detectedOn: "2025-04-22",
      impact: "Medium",
    },
    {
      key: "3",
      trend: "Reduced Incident Frequency",
      category: "Compliance",
      detectedOn: "2025-04-20",
      impact: "Low",
    },
    {
      key: "4",
      trend: "Faster Delivery Cycles",
      category: "Logistics",
      detectedOn: "2025-04-18",
      impact: "High",
    },
  ];

  // Define business trend columns
  const businessTrendColumns = [
    {
      title: "Trend",
      dataIndex: "trend",
      key: "trend",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (cat) => <Tag color="blue">{cat}</Tag>,
    },
    {
      title: "Detected On",
      dataIndex: "detectedOn",
      key: "detectedOn",
    },
    {
      title: "Impact",
      dataIndex: "impact",
      key: "impact",
      render: (impact) => {
        let color =
          impact === "High" ? "red" : impact === "Medium" ? "orange" : "green";
        return <Tag color={color}>{impact}</Tag>;
      },
    },
  ];

  // Dummy market trends list
  const marketTrends = [
    { title: "AI Adoption Rising in Finance Sector", tag: "AI" },
    { title: "New EU Regulations on Data Privacy", tag: "Legal" },
    { title: "Cyber Threats Up 25% in Q2", tag: "Cybersecurity" },
    { title: "Cloud Cost Optimization Demand Grows", tag: "Cloud" },
  ];

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Radar Overview System
        </Title>
        <Text type="secondary" style={{ fontSize: 12, marginBottom: 10 }}>
          Show high-level trends detected.
        </Text>
      </div>
      <Dashboard />
      <div style={{ padding: "20px 0px" }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card title="📊 Business Trends (Internal)">
              <Table
                columns={businessTrendColumns}
                dataSource={businessTrendData}
                pagination={false}
                size="middle"
              />
            </Card>
          </Col>

          <Col span={24}>
            <Card title="🌍 Market Trends (External)">
              <List
                dataSource={marketTrends}
                renderItem={(item) => (
                  <List.Item>
                    <Tag color="green">{item.tag}</Tag>
                    {item.title}
                  </List.Item>
                )}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default RadarOverview;
